import type { TFunction } from 'i18next';
import { Typography } from '@mui/material';
import theme from '../../../../theme/theme';

export function DependentBoolCell({ value, t }: { value: boolean | undefined; t: TFunction }) {
  return (
    <Typography variant="body2" sx={{ fontSize: '0.85rem', color: theme.palette.text.body }}>
      {value === undefined ? '-' : value ? t('table.filter.yes') : t('table.filter.no')}
    </Typography>
  );
}
